



























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import MarketplaceTextInput from '../../components/MarketplaceTextInput/index.vue'
import MarketplaceDropdown from '../../components/MarketplaceDropdown/index.vue'
import POSController from '@/app/ui/controllers/POSController'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import { POS } from '@/domain/entities/POS'
import dayjs from 'dayjs'
import dayjsID from 'dayjs/locale/id'
import MarketplaceInputPhone from '../../components/MarketplaceInputPhone/index.vue'
import RadioButton from '@/app/ui/components/RadioButton/index.vue'
import {
  ALL_SELLER_ROLE_OPTIONS,
  EnumAssignTo,
  EnumSellerRole,
} from '@/app/infrastructures/misc/Constants/manageWhitelist'
import PODController from '@/app/ui/controllers/PODTrackerController'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import { ShowSellerPhoneRequest } from '@/data/payload/api/WhiteSellerRequest'
import ManageCourierController from '@/app/ui/controllers/ManageCourierController'
import { ShowCourierPhoneRequest } from '@/data/payload/api/ManageCourierRequest'
import { WhiteSellerPickupPoint } from '@/domain/entities/WhiteSeller'
import { Pagination } from '@/domain/entities/Pagination'

interface OptionsNumber {
  label: string
  value: number
}

interface OptionsString  {
  label: string
  value: string
}

interface WhiteSeller {
  id: number
  name: string
  phone: string
  status: string
  partnerId: number
  partnerPOS: string
  role: string
  codHandling?: string
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
  courierId: string
  courierName: string
  assignType: string
  clientId?: number
  clientName?: string
}

@Component({
  components: {
    Button,
    DropdownSelect,
    MarketplaceTextInput,
    MarketplaceDropdown,
    MarketplaceInputPhone,
    RadioButton,
    LoadingOverlay
  },
})
class DetailSellerWhitelist extends Vue {
  PODController = PODController
  POSController = POSController
  WhiteSellerController = WhiteSellerController
  statusOptions = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]
  // Includes legacy MERCHANT and COMPANY; labels are resolved by value
  sellerRoleOptions = ALL_SELLER_ROLE_OPTIONS
  codHandlingOptions = [
    {
      label: '-',
      value: ''
    },
    {
      label: 'specialcod',
      value: 'specialcod'
    },
    {
      label: 'standardcod',
      value: 'standardcod'
    }
  ]
  partnerPOSOptions = <OptionsNumber[]>([])
  assignTypeOptions: OptionsString[] = [
    {
      label: 'Offer',
      value: 'OFFER',
    },
    {
      label: 'Auto Assign',
      value: 'AUTO ASSIGN',
    },
  ]
  form = {
    name: '',
    phone: '',
    status: this.statusOptions[0],
    agentId: [] as Record<string, any>,
    sellerRole: [] as Record<string, any>,
    codHandling: [] as Record<string, any>,
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
    phoneCode: '',
    assignTo: '',
    courier: [] as Record<string, any>,
    assignType: [] as Record<string, any>,
    clientId: undefined as number | undefined,
    clientName: '',
  }
  currentPartnerId = 0
  isActiveStatus = true
  paramsPartnerPOS = {
    page: 1,
    per_page: 100,
    search: '',
    sort_by: 'ASC',
  }
  isAllData = false;

  // Bound pickup points state for Corporate (COMPANY)
  pickupPoints: WhiteSellerPickupPoint[] = []
  pickupPointPagination = new Pagination(1, 50, 0)
  isLoadingPickupPoints = false
  isPickupPointError = false
  private activeRevealToken = 0

  created(): void {
    this.fetchData()
  }

  get isLoading() {
    return WhiteSellerController.isLoading || POSController.isLoadingPOS;
  }

  get isCorporate(): boolean {
    return this.form.sellerRole[0]?.value === EnumSellerRole.COMPANY
  }

  get showCODHandlingDropdown(): boolean {
    return this.form.sellerRole[0]?.value === 'CLIENT'
  }

  get totalPickupPointPages(): number {
    const total = this.pickupPointPagination.totalItem || 0
    const limit = this.pickupPointPagination.perPage || 50
    return Math.ceil(total / limit) || 1
  }

  private async fetchData(posOnly?: boolean) {
    await POSController.getPOSData(this.paramsPartnerPOS)
    if (!posOnly) {
      await WhiteSellerController.getDetail(this.$route.params.id)
    }
  }

  private onEdit() {
    const id = this.$route.params.id
    this.$router.push(`/marketplace/manage-whitelist/edit/${id}`)
  }

  private onPhoneCodeChange(phoneCode: string) {
    this.form.phoneCode = phoneCode
    this.form.phone = this.form.phone.replaceAll(this.form.phoneCode, '')
  }

  private maxLengthIndonesianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.phone.length <= 13
    }
    return true
  }

  private minLengthIndosianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.phone.length >= 9
    }
    return true
  }

  @Watch('POSController.posData')
  setPOSPartner(data: POS[]): void {
    const POSOptions = data.map(item => {
      return {
        label: `${item.name} [${item.code}]`,
        value: item.id
      }
    }) as OptionsNumber[]
    this.partnerPOSOptions = POSOptions
    this.form.agentId = <OptionsNumber>POSOptions.find(item => item.value === this.currentPartnerId)
  }

  @Watch('WhiteSellerController.dataWhiteSeller')
  async updateForm(val: WhiteSeller): Promise<void> {
    if (val && (val.id || val.name || val.role || val.status)) {
      // Set Partner POS
      this.paramsPartnerPOS = {
        ...this.paramsPartnerPOS,
        search: <string>val.partnerPOS
      }
      this.currentPartnerId = <number>val.partnerId
      await this.fetchData(true)

      let courierLabel = `${val.courierId} - ${val.courierName}`

      if (val.courierId) {
        await this.PODController.getDriverList({q: val.courierName});
        const courierData = this.PODController.driverData.find(driver => driver.courierId === Number(val.courierId));
        if (courierData) courierLabel = `[${courierData.courierId}] ${courierData.fullname} (${courierData.announcementCourierType}) ******** • ${courierData.partnerName}`;
      }

      if (val.status === 'ACTIVE') {
        this.isActiveStatus = true
      } else {
        this.isActiveStatus = false
      }

      this.form = {
        name: <string>val.name,
        phone: '',
        status: <OptionsString>this.statusOptions.find(item => item.value === val.status) || this.statusOptions[0],
        agentId: this.partnerPOSOptions.filter(item => item.value === val.partnerId),
        sellerRole: this.sellerRoleOptions.filter(item => item.value === val.role),
        codHandling: <OptionsString>this.codHandlingOptions.find(item => item.value === val.codHandling) || this.codHandlingOptions[0],
        createdAt: val.createdAt ? `${dayjs(val.createdAt).locale(dayjsID).format('DD MMMM YYYY, HH:mm')} WIB` : '-',
        createdBy: val.createdBy || '-',
        updatedAt: val.updatedAt ? `${dayjs(val.updatedAt).locale(dayjsID).format('DD MMMM YYYY, HH:mm')} WIB` : '-',
        updatedBy: val.updatedBy || '-',
        phoneCode: '',
        assignTo:
          val.courierId && val.assignType
            ? this.enumAssignTo.COURIER
            : this.enumAssignTo.POS,
        courier: {
          label: courierLabel,
          value: val.courierId,
        },
        assignType: this.assignTypeOptions.filter(
          item => item.value === val.assignType?.toUpperCase()
        ),
        clientId: val.clientId,
        clientName: val.clientName || '',
      }

      // Fetch bound pickup points if role is Corporate (COMPANY)
      if (val.role === EnumSellerRole.COMPANY) {
        await this.fetchBoundPickupPoints(1, false ,false, true)
      }
    }
  }

  enumAssignTo = EnumAssignTo

  async fetchBoundPickupPoints(page = 1, reveal = false, append = false, loading = false) {
    const token = ++this.activeRevealToken
    this.isLoadingPickupPoints = loading
    this.isPickupPointError = false
    try {
      const resp = await WhiteSellerController.getBoundPickupPoints({
        id: String(this.$route.params.id),
        page,
        limit: 50,
        reveal,
      })

      // If token changed (e.g. user toggled off before response arrived), discard stale response
      if (token !== this.activeRevealToken) return

      if (append) {
        this.pickupPoints = [...this.pickupPoints, ...resp.data]
      } else {
        this.pickupPoints = resp.data
      }
      this.pickupPointPagination = resp.pagination
    } catch (e) {
      if (token === this.activeRevealToken) {
        this.isPickupPointError = true
      }
    } finally {
      if (token === this.activeRevealToken) {
        this.isLoadingPickupPoints = false
      }
    }
  }

  async retryFetchPickupPoints() {
    await this.fetchBoundPickupPoints(this.pickupPointPagination.page || 1, this.isAllData, false)
  }

  async loadNextPickupPoints() {
    const nextPage = (this.pickupPointPagination.page || 1) + 1
    await this.fetchBoundPickupPoints(nextPage, this.isAllData, true)
  }

  async showSellerPhoneNumber() {
    try {
      WhiteSellerController.setLoading(true);
      const resp = await WhiteSellerController.showWhitelistSellerPhone(new ShowSellerPhoneRequest({
        id: Number(this.$route.params.id),
        source: "whitelist-detail",
        type: WhiteSellerController.dataWhiteSeller.role
      }))
      this.form.phone = resp.phone
    } finally {
      WhiteSellerController.setLoading(false);
    }
  }

  async showCourierPhoneNumber() {
    const val = WhiteSellerController.dataWhiteSeller;
    if (!val.courierId) return;
    const resp = await ManageCourierController.showCourierPhone(new ShowCourierPhoneRequest({
      id: Number(val.courierId),
      source: "whitelist-detail",
      type: val.role
    }))

    let courierLabel = this.form.courier.label;

    const courierData = this.PODController.driverData.find(driver => driver.courierId === Number(val.courierId));
    if (courierData) courierLabel = `[${courierData.courierId}] ${courierData.fullname} (${courierData.announcementCourierType}) ${resp} • ${courierData.partnerName}`;
    this.form.courier.label = courierLabel;
  }

  async onToggleAllData() {
    if (!this.isAllData) {
      this.isAllData = true
      await this.showCourierPhoneNumber();
      await this.showSellerPhoneNumber();
      if (this.isCorporate) {
        await this.fetchBoundPickupPoints(1, true, false)
      }
    } else {
      // Invalidate in-flight tokens
      this.activeRevealToken++
      this.isAllData = false;
      const val = WhiteSellerController.dataWhiteSeller;
      this.form.phone = "";
      this.form.phoneCode = "";

      if (val.courierId) {
        let courierLabel = this.form.courier.label;

        const courierData = this.PODController.driverData.find(driver => driver.courierId === Number(val.courierId));
        if (courierData) courierLabel = `[${courierData.courierId}] ${courierData.fullname} (${courierData.announcementCourierType}) ******** • ${courierData.partnerName}`;
        this.form.courier.label = courierLabel;
      }

      if (this.isCorporate) {
        await this.fetchBoundPickupPoints(1, false, false)
      }
    }
  }

  get sellerRoleLabel(): string {
    return this.form.sellerRole[0]?.label || '-'
  }

  get agentIdLabel(): string {
    return this.form.agentId[0]?.label || '-'
  }

  get assignTypeLabel(): string {
    return this.form.assignType[0]?.label || '-'
  }

}
export default DetailSellerWhitelist;
